import { render, staticRenderFns } from "./BasicInfoEnterpriseGeneric.pug?vue&type=template&id=68842b2a&scoped=true&lang=pug&"
import script from "./BasicInfoEnterpriseGeneric.vue?vue&type=script&lang=js&"
export * from "./BasicInfoEnterpriseGeneric.vue?vue&type=script&lang=js&"
import style0 from "./BasicInfoEnterpriseGeneric.scss?vue&type=style&index=0&id=68842b2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68842b2a",
  null
  
)

export default component.exports